import { FC, useEffect } from 'react';
import { useMethods } from '@lhb/hook';
import { deepCopy, isEqual } from '@lhb/func';
import { Form } from 'antd';
import FormSetName from 'src/common/components/Form/FormSetName/FormSetName';
import Main from './Main';

/**
 * 动态表单编辑-AI预测进店率
 * @description
 * @demo
 */
const Component:FC<{
  form: any;
  formItemData: any;
  disabled?: boolean;
  valueChange?: any
}> = ({ form, formItemData, disabled, valueChange }) => {

  /* state */
  const identification = formItemData.identification; // 字段
  /** 预测结果 */
  const value = Form.useWatch(identification) || {};

  /* hooks */
  useEffect(() => {
    methods.updateValue();
  }, [value]);

  /* methods */

  const methods = useMethods({

    /** 预测完成 */
    handlePredictComplete(data: any) {
      form.setFieldValue(identification, deepCopy(data));
      valueChange?.(identification, deepCopy(data));
    },

    /** 更新值 */
    updateValue() {
      /**
       * value 变更时，获取 name 更新到 value 对象字段上
       * value 和后端约定需要包含
       {
        'storeSequence',
        'storeSequenceName',
        'cooperationStatus',
        'cooperationStatusName',
        'storeExpansionStatus',
        'storeExpansionStatusName',
      }
      */
      const _value = deepCopy(value || {});
      if (Object.keys(_value).length) { // 避免空对象

        if (!isEqual(_value, value)) {
          console.log('更新后的值:', JSON.parse(JSON.stringify(_value)));
          form.setFieldValue(identification, deepCopy(_value));
          valueChange?.(identification, deepCopy(_value));
        }
      }
    },

  });

  return (<div className={'mb-20'}>
    <FormSetName name={identification} initialValue={{}}></FormSetName>
    <Main data={value} disabled={disabled} className={'mt-20'} complete={methods.handlePredictComplete} />
  </div>);
};

export default Component;
